import { Record, List } from "immutable";
import moment from "moment";

interface IChargebackEvidence {
    id: string;
    chargeback_id: string;
    defense_document_type_code: string;
    defense_document_url: string;
    defense_document_filename: string;
    defense_original_filename: string;
    document_description: string;
    submitted_to_adyen: boolean;
    archived: boolean;
    created_on: moment.Moment;
    modified_on: moment.Moment;
    __meta: IMeta;
}

interface IMeta {
    __actions: any[];
}

const defaults = {
    id: undefined,
    brand_id: undefined,
    payment_account_id: undefined,
    company_id: undefined,
    company_name: undefined,
    transaction_id: undefined,
    payment_group_id: undefined,
    order_number: undefined,
    order_id: undefined,
    dispute_id: undefined,
    status: undefined,
    reason: undefined,
    currency_code: undefined,
    current_event_code: undefined,
    event_code_description: undefined,
    merchant_account_code: undefined,
    psp_reference: undefined, // id of dispute in Adyen
    original_reference: undefined,
    payment_method: undefined,
    amount: undefined,
    archived: undefined,
    event_date: undefined,
    resolve_by: undefined,
    defense_reasons: undefined,
    evidence: undefined,
    __meta: undefined,
    created_on: undefined,
    modified_on: undefined,
};

const convertEvidence = (evidence) => {
    return evidence.map(
        ({
            id,
            chargeback_id,
            defense_document_type_code,
            defense_document_url,
            defense_document_filename,
            defense_original_filename,
            document_description,
            submitted_to_adyen,
            archived,
            created_on,
            modified_on,
            __meta,
        }) => {
            return {
                id,
                chargeback_id,
                defense_document_type_code,
                defense_document_url,
                defense_document_filename,
                defense_original_filename,
                document_description,
                submitted_to_adyen,
                archived,
                created_on: moment.utc(created_on),
                modified_on: moment.utc(modified_on),
                __meta,
            };
        }
    );
};

export class Chargeback extends Record(defaults) {
    declare id: string;
    declare brand_id: string;
    declare payment_account_id: string;
    declare company_id: string;
    declare company_name: string;
    declare transaction_id: string;
    declare payment_group_id: string;
    declare order_number: string;
    declare order_id: string;
    declare dispute_id: string;
    declare status: string;
    declare reason: string;
    declare currency_code: string;
    declare current_event_code: string;
    declare event_code_description: string;
    declare merchant_account_code: string;
    declare psp_reference: string;
    declare original_reference: string;
    declare payment_method: string;
    declare amount: number;
    declare archived: boolean;
    declare event_date: moment.Moment;
    declare resolve_by: moment.Moment;
    declare defense_reasons?: any[];
    declare evidence?: List<IChargebackEvidence>;
    declare __meta: IMeta;
    declare created_on: moment.Moment;
    declare modified_on: moment.Moment;

    constructor(args) {
        super({
            ...args,
            resolve_by: moment.utc(args.resolve_by),
            event_date: moment.utc(args.event_date),
            created_on: moment.utc(args.created_on),
            modified_on: moment.utc(args.modified_on),
            evidence: args.evidence ? List(convertEvidence(args.evidence)) : List(),
        });
    }

    canDeleteEvidence(id): boolean {
        const specificEvidence = this.evidence.find((evidence) => evidence.id === id);
        const canDeleteEvidence =
            specificEvidence &&
            specificEvidence.__meta.__actions.find((action) => action.__key === "__delete_evidence") !== undefined;
        return canDeleteEvidence;
    }
}
